
import { Options, Prop, Vue } from 'vue-property-decorator';
import type { NAttachment } from './types';

@Options({})
export default class NAttachmentsList extends Vue {
  @Prop({ required: true, type: Array })
  readonly attachments!: ReadonlyArray<Readonly<NAttachment>>;
}
